import { faNumber } from '../../lib/faNumbers'
import styles from './NetworkStrip.module.css'

interface NetworkStripProps {
  isOnline: boolean
  queuedCount: number
}

export function NetworkStrip({ isOnline, queuedCount }: NetworkStripProps) {
  return (
    <footer className={styles.strip}>
      <span className={styles.state}>
        <span
          className={`${styles.dot} ${isOnline ? styles.online : styles.offline}`}
          aria-hidden="true"
        />
        {isOnline ? 'آنلاین · همگام‌سازی فعال' : 'شبکه قطع · ذخیره روی دستگاه'}
      </span>

      <span className={styles.queue}>{faNumber(queuedCount)} در صف</span>
    </footer>
  )
}
